import { PORTAL_CONTAINER_ID, TextKey } from '@mews-distributor/common';
import { LocalizedText } from '@mews/framework';
import { Body, Dialog, DialogProps } from '@optimus-web/core';
import {
    isAppInitialized as isAppInitializedSelector,
    isInvalidIframe as isInvalidIframeSelector,
} from '../../../modules/app/selectors';
import { useAppDispatch, useAppSelector } from '../../../utils/redux';
import { redirectToStandalone } from './actions';

export const StandaloneDialog = () => {
    const isAppInitialized = useAppSelector(isAppInitializedSelector);
    const isInvalidIframe = useAppSelector(isInvalidIframeSelector);
    const dispatch = useAppDispatch();
    const isDisplayed = isAppInitialized && isInvalidIframe;

    if (!isDisplayed) {
        return null;
    }

    const dialogActions: DialogProps['actions'] = [
        {
            variant: 'primary',
            children: <LocalizedText textKey={TextKey.Continue} />,
            onClick: () => dispatch(redirectToStandalone()),
            type: 'submit',
        },
    ];

    return (
        <Dialog
            active
            title={<LocalizedText textKey={TextKey.Booking} />}
            actions={dialogActions}
            portalContainerId={PORTAL_CONTAINER_ID}
        >
            <Body>
                <LocalizedText textKey={TextKey.IncorrectIframeDialogMessage} />
            </Body>
        </Dialog>
    );
};
